import { routes } from 'utils/routing';

export const DeepLinks = {
  loyaltyRewardsDashboard: routes.loyaltyDashboard,
};
